export default __webpack_public_path__ + "static/media/groceries.de3fa76e.png";